<template>
    <div :class="{'background-ski': isSkiEvent, 'background-snowman': isSnowmanEvent}">

        <article class="ama" :class="{'ama-ski': isSkiEvent, 'ama-snowman': isSnowmanEvent}">

            <h1>{{ $t('landing_consent_title_landing') }}</h1>

            <p>{{ $t('landing_consent_subtitle_description') }}</p>

            <button @click="instantApp" :class="{'cta-winter': seasonalEvent}">{{ $t('consent_cta_continue') }}</button>

            <img src="/img/seasonal/winter/foxy-ski.svg" class="foxy-ski" v-show="isSkiEvent">
            <img src="/img/seasonal/winter/foxy-snowman.svg" class="foxy-snowman" v-show="isSnowmanEvent">

        </article>
    </div>
</template>

<script>
import Vuex from 'vuex'
import ENUM from '../../assets/ENUM'

import Tag from '../../modules/tag'

export default {

    name: 'article-1-mobile-android',

    computed: {
        ...Vuex.mapGetters([
            'seasonalEvent'
        ]),

        isSkiEvent() {
            return this.seasonalEvent === ENUM.SEASONAL.WINTER.WINTER_SKI
        },

        isSnowmanEvent() {
            return this.seasonalEvent === ENUM.SEASONAL.WINTER.WINTER_SNOWMAN
        }
    },

    methods: {

        instantApp() {
            Tag.clickAll(this, 'continue_instant_app', undefined, 'landing')
            window.open('https://play.google.com/store/apps/details?id=io.cleanfox.android&launch=true', '_blank', 'rel="noopener,noreferrer,nofollow"')
        }
    }
}
</script>

<style lang="scss" scoped>

.ama {
    background-image: url("/img/background/fetch-mobile.svg");
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: cover;
    background-color: $blue;
    padding: 100px 16px 156px;
    color: $charcoal;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    h1 {
        font-size: 28px;
        font-weight: bold;
        line-height: 1.14;
    }

    p {
        margin-top: 16px;
        font-size: 15px;
        line-height: 1.33;
    }

    button {
        width: 100%;
        margin-top: 48px;
        padding: 16px 40px;
        font-size: 17px;
        font-weight: 600;
        line-height: 1.41;
        letter-spacing: normal;
        color: $white;
        border-radius: 32px;
        background-color: $midnight;
    }
}

//SEASONAL

.ama-ski {
    padding-bottom: 200px;
    background-image: url("/img/seasonal/winter/background-ski.svg");
    background-color: inherit;
    color: $white;
    background-position: bottom;
}

.ama-snowman {
    padding-bottom: 200px;
    background-image: url("/img/seasonal/winter/background-snowman.svg");
    background-color: inherit;
    color: $white;
    background-position-y: 48px;
}

.background-ski {
    background: linear-gradient(180deg, #2C6096 0%, #011C38 100%);
    position: relative;
}

.background-snowman {
    background: linear-gradient(180deg, #153F5F 0%, #0B1330 100%);
    position: relative;
}

.ama .cta-winter {
    border: 4px solid $neutralsPlatinum;
    background-color: $white;
    color: $charcoal
}

.foxy-ski {
    width: 90px;
    object-fit: contain;
    position: absolute;
    left: 80px;
    bottom: 9px;
}

.foxy-snowman {
    width: 130px;
    object-fit: contain;
    position: absolute;
    bottom: 9px;
}

</style>

